// Shared palette definitions; values and helpers are maintained here.


// Single source of truth for every colour/label mapping used across the app:
// the legend, the map (node markers + rings + pulses), the packet feed, and
// the detail panels all import from here so nothing is ever defined twice
// (BUILD THIS #6: the same name must be used in the legend, the feed, the
// map and the detail panels).
//
// Palette source: validated categorical/status palette (8-hue categorical set,
// fixed order, CVD-checked; 4-step status palette). See the dataviz reference
// this app was built against for the underlying Delta-E validation — the hex
// values below are copied verbatim, not re-derived.
//
// PROTOCOLS ARE PEERS (correcting an earlier draft of this file that
// flattened MeshCore and Meshtastic roles into one shared "repeater / client
// / gateway / sensor / observer" taxonomy — Meshtastic-as-base thinking,
// which the whole platform design explicitly rejects, see
// amalgamesh-v2-design.md §1). Role and packet-type vocabularies are kept as
// two independent, protocol-scoped tables below. Nothing here maps a
// MeshCore value onto a Meshtastic name or vice versa.

export type ThemeMode = "light" | "dark";


export const CATEGORICAL: Record<string, { light: string; dark: string }> = {
  blue: { light: "#2a78d6", dark: "#3987e5" },
  orange: { light: "#eb6834", dark: "#d95926" },
  aqua: { light: "#1baf7a", dark: "#199e70" },
  yellow: { light: "#eda100", dark: "#c98500" },
  magenta: { light: "#e87ba4", dark: "#d55181" },
  green: { light: "#008300", dark: "#008300" },
  violet: { light: "#4a3aa7", dark: "#9085e9" },
  red: { light: "#e34948", dark: "#e66767" },
};


export const STATUS = {
  good: { light: "#0ca30c", dark: "#0ca30c" },
  warning: { light: "#fab219", dark: "#fab219" },
  serious: { light: "#ec835a", dark: "#ec835a" },
  critical: { light: "#d03b3b", dark: "#d03b3b" },
};


export const CHROME = {
  surface: { light: "#fcfcfb", dark: "#1a1a19" },
  page: { light: "#f9f9f7", dark: "#0d0d0d" },
  ink: { light: "#0b0b0b", dark: "#ffffff" },
  inkSecondary: { light: "#52514e", dark: "#c3c2b7" },
  inkMuted: { light: "#898781", dark: "#898781" },
  gridline: { light: "#e1e0d9", dark: "#2c2c2a" },
  border: { light: "rgba(11,11,11,0.10)", dark: "rgba(255,255,255,0.10)" },
};


export const OTHER_COLOR = { light: CHROME.inkMuted.light, dark: CHROME.inkMuted.dark };


export function colorFor(pair: { light: string; dark: string }, mode: ThemeMode): string {
  return mode === "dark" ? pair.dark : pair.light;
}
